import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  icon: LucideIcon;
  label: string;
  value: string;
  subvalue?: string;
}

const StatCard: React.FC<StatCardProps> = ({ icon: Icon, label, value, subvalue }) => {
  return (
    <div className="glass-card rounded-xl p-4 border border-black/[0.08]">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-8 h-8 rounded-lg bg-white/60 border border-black/[0.06] flex items-center justify-center">
          <Icon className="w-4 h-4 text-[#64748b]" />
        </div>
        <span className="text-[#64748b] text-sm">{label}</span>
      </div>
      <div className="text-xl font-bold text-[#0f172a]">{value || '—'}</div>
      {subvalue && <div className="text-[#94a3b8] text-xs mt-1">{subvalue}</div>}
    </div>
  );
};

export default StatCard;
